import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: " p-d-flex p-flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-m-2" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.KpiDocumentDesignerTypeCardDescriptor.typeOptions, (option, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "field-radiobutton p-mx-2",
            key: index
          }, [
            _createVNode(_component_RadioButton, {
              id: option.value,
              value: option.value,
              modelValue: _ctx.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.type = $event)),
              onChange: _ctx.onTypeChange
            }, null, 8, ["id", "value", "modelValue", "onChange"]),
            _createVNode("label", {
              for: option.value,
              class: "p-ml-2"
            }, _toDisplayString(_ctx.$t(option.label)), 9, ["for"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}